import { createRouter, createWebHistory } from "vue-router";
import Login from "../views/Auth/Login.vue";
import Maintenance from "../views/Auth/Maintenance2.vue";
import { useUserStore } from "../stores/user";
import { useLicenseStore } from "../stores/license";

import { storeToRefs } from "pinia";

const routesDefinition = {
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: "/",
      name: "home",
      redirect: (to) => ({ path: "/dashboard" }),
    },
    {
      path: "/login",
      name: "login",
      component: Login,
    },
    {
      path: "/maintenance",
      name: "maintenance",
      component: Maintenance,
    },
    {
      path: "/cloudkeeper-activated",
      name: "cloudkeeper_activated",
      component: () => import("../views/Public/CloudkeeperActivated.vue"),
    },
    {
      path: "/dashboard",
      name: "dashboard",
      component: () => import("../views/Dashboard/Dashboard.vue"),
    },
    // {
    //   path: "/licenses",
    //   name: "licenses",
    //   component: () => import("../views/License/LicenseList.vue"),
    // },
    {
      path: "/license_list",
      name: "license_list",
      component: () => import("../views/License/ZSLicenseList.vue"),
    },
    {
      path: "/icons",
      name: "icons",
      component: () => import("../views/Temp/IconShow.vue"),
    },
    {
      path: "/local_license_list",
      name: "local_license_list",
      component: () => import("../views/License/ZSLocalLicenseList.vue"),
    },
    {
      path: "/expired_licenses",
      name: "expired_licenses",
      component: () => import("../views/License/ExpiredLicenses.vue"),
    },

    {
      path: "/pending_licenses",
      name: "pending_licenses",
      component: () => import("../views/License/PendingLicenses.vue"),
    },
    {
      path: "/new_license",
      name: "new_license",

      component: () => import("../views/License/NewLicense.vue"),
    },
    {
      path: "/new_store/:serial?",
      name: "new_store",
      component: () => import("../views/Store/StoreForm.vue"),
      props: (route) => ({
        ...route.params,
        partnerNif: useUserStore().user.partner_tax,
      }),
    },
    {
      path: "/edit_store/:serial/:store_id",
      name: "edit_store",
      component: () => import("../views/Store/StoreForm.vue"),
      props: (route) => ({
        ...route.params,
        partnerNif: useUserStore().user.partner_tax,
      }),
    },
    {
      path: "/store_list/:serial/:certinfo?",
      name: "store_list",
      component: () => import("../views/Store/StoreList.vue"),
      props: true,
    },
    {
      path: "/leads",
      name: "leads",
      component: () => import("../views/Leads/Lead.vue"),
      props: true,
    },
    {
      path: "/manuals_setups",
      name: "manuals_setups",
      component: () => import("../views/Docs/ManualsSetups.vue"),
    },
    {
      path: "/release_notes",
      name: "release_notes",
      component: () => import("../views/Docs/ReleaseNotes.vue"),
    },
    {
      path: "/moodle_users",
      name: "moodle_users",
      component: () => import("../views/Docs/MoodleUsers.vue"),
    },
  ],
};

if (import.meta.env.VITE_PLAYGROUND === "true") {
  routesDefinition.routes.push({
    path: "/playground",
    name: "playground",
    component: () => import("../views/Playground/Playground.vue"),
  });
  routesDefinition.routes.push({
    path: "/playground/dashgrid",
    name: "playground-dashgrid",
    component: () => import("../views/Playground/DashGridDemo.vue"),
  });
}

const router = createRouter(routesDefinition);

router.beforeEach(async (to, from) => {
  const userStore = useUserStore();
  const { isLogged, maintenance ,user} = storeToRefs(userStore);

  if (to.name == "maintenance") {
    return true;
  }

  if (!isLogged.value && !["login", "cloudkeeper_activated"].includes(to.name)) {
    return { name: "login" };
  }
  
  if (to.meta.adminOnly === true && user.value.admin != 1) {
    return { name: "licenses" };
  }

  if (to.meta.permission) {
    if (!userStore.rbacStateLoaded) {
      await userStore.refreshRBACState();
    }

    if (!userStore.hasPermission(to.meta.permission)) {
      return { name: "dashboard" };
    }
  }


  const licenseStore = useLicenseStore();

  if (
    (["licenses"].includes(from.name) &&
      !["store_list", "new_store", "edit_store", "new_license"].includes(
        to.name
      )) ||
    (["store_list", "new_store", "edit_store", "new_license"].includes(
      from.name
    ) &&
      !["licenses"].includes(to.name))
  ) {
    licenseStore.resetFilters();
  }
});

export default router;
